import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import registerIcon1 from 'assets/img/ico_registration_01.png';
import registerIcon2 from 'assets/img/ico_registration_02.png';
import registerIcon3 from 'assets/img/ico_registration_03.png';
import './register.scss';

//own components
import Head from 'components/metatags_helmet/metatags';
import RegisterComp from 'components/register/RegisterComp';
import TitleWithLine from 'components/titleWithLine';

const Register = () => {
  const { t } = useTranslation(['register']);

  useEffect(() => {
    goUp();
  }, []);

  const goUp = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="container-fluid mainDiv">
      <Head title={t('register')} noIndex={true} />
      <Row className="mainRow register mx-1 w-100">
        <Col lg={12}>
          <div className="row">
            <div className="col-md-12">
              <TitleWithLine text={t('freeregister')} />
            </div>
          </div>
          <p>
            {t('markedfields')} <span className="orange"> * </span> {t('obligatoryfields')}
          </p>
          <RegisterComp />
          <p>{t('information')}</p>
        </Col>
      </Row>
    </div>
  );
};

export default Register;
